import React, { useEffect, Fragment} from 'react'
import { useGlobal } from "reactn";
import 'leaflet/dist/leaflet.css';
import HeaderBar from '../../../components/atoms/headerBar/HeaderBar';
import GridBackground from '../../molecules/gridBackround/GridBackground'
import styles from './Contact.module.scss'

const Contact = () => {

  const [, setshowDataLookup] = useGlobal('showDataLookup')

  // eslint-disable-next-line
  useEffect(() => {setshowDataLookup([])}, [])

  return (
    <Fragment>
      <div className="NavContainer">
        <HeaderBar />
      </div>
      <div className={styles.outer}>
      <div className={styles.content}>
        <GridBackground>
          <div className={styles.pageContent}>
          <h1>Contact</h1>

          <p>  For enquiries about the analysis, please contact info@grid3.org </p></div>
        </GridBackground>
      </div>
      </div>
    </Fragment>
  );
}


export default Contact

